/* import __COLOCATED_TEMPLATE__ from './reply-author-filter.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { REPORTING_FILTER_SELECT_ALL } from 'embercom/lib/reporting/flexible/constants';

export default class TeammateParticipatedFilter extends Component {
  @service appService;
  @service intercomEventService;
  @tracked availableTeammates = this.appService.app.humanAdmins.filter(
    (admin) => !admin?.is_redacted,
  );
  @tracked label = this.currentLabel;
  selectedDropdownItems = this.args.selected.values || [];

  get items() {
    return [
      {
        heading: 'Teammates',
        items: this.allItems,
      },
    ];
  }

  get allItems() {
    return this.availableTeammates.map((teammate) => ({
      model: teammate,
      text: teammate.display_as_assignee,
      value: teammate.id.toString(),
      component: 'reporting/flexible/filter-bar/teammate-item',
      isSelected: this.selectedDropdownItems.includes(teammate.id.toString()),
    }));
  }

  get selectedTeammateIds() {
    return this.selectedDropdownItems.filter((item) => item !== REPORTING_FILTER_SELECT_ALL);
  }

  get currentLabel() {
    if (this.selectedTeammateIds.length === 0) {
      return 'Any';
    }

    let teammateNames = this.selectedTeammateIds.map((teammateId) => {
      return (
        this.availableTeammates.find((teammate) => teammate.id.toString() === teammateId)
          ?.display_as_assignee || 'Former Teammate'
      );
    });
    return teammateNames.join(', ');
  }

  @action
  onClose() {
    if (this.isDestroying) {
      // for some reason onClose gets triggered when you remove the filter
      // even if the dropdown isn't currently open
      return;
    }

    if (!this.selectedDropdownItems.length) {
      this.selectedDropdownItems = [REPORTING_FILTER_SELECT_ALL];
    }

    this.intercomEventService.trackAnalyticsEvent({
      action: 'filtered_reply_author',
      object: this.args.analyticsObject,
      teammate_count: this.selectedTeammateIds.length,
    });

    this.args.setSelected(this.selectedDropdownItems);
    this.label = this.currentLabel;
  }

  @action
  removeFilter() {
    this.selectedDropdownItems = [];
    this.args.removeFilter();
  }
}
